import React from 'react';
import { useTranslation } from '@pascal/pascal-core';

const TabItem = ({ onChange, value, label, selectedValue, replayActiveMainMoreSection }) => {
  const t = useTranslation();

  return (
    <div
      className={`mob-game-tab-item ${
        (value === selectedValue && !replayActiveMainMoreSection) ||
        replayActiveMainMoreSection === value
          ? 'active'
          : ''
      }`}
      onClick={() => onChange(value)}
    >
      <span className='mob-game-tab-item-name'>{t(label)}</span>
    </div>
  );
};

export default TabItem;
